
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {Container, Card, Form, Button} from "react-bootstrap";
import axios from 'axios';
import AdminDashboardLayout from "../../../Components/AdminDashboard/AdminDashboardLayout";
import Loading from 'react-fullscreen-loading';
import { toast } from "react-hot-toast";
import ModulesList from '../../../Components/ModulesList/ModulesList';
import { slugify } from '../../../utils/slugify';

export default function CreateService() {
  const navigate = useNavigate();

  const [screenloader, setScreenloader] = useState(false);
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [active, setActive] = useState(1);
  const [modules, setModules] = useState([]);

  const handleNameChange = (e) => {
    const newName = e.target.value;
    setName(newName);
    setSlug(slugify(newName));
  };

  const handleSubmit = async () => {
    if (!name || !slug) {
      toast.error('Name and slug cannot be empty');
      return;
    }
    setScreenloader(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/admin/services`, {
        name,
        slug,
        active,
        modules,
      }, {
        headers: {
          'access-token': localStorage.getItem('accessToken'),
        }
      });

      setScreenloader(false);
      if (res.data.status) {
        toast.success('Service Created Successfully');
        navigate('/Admin/Services');
      } else {
        toast.error('Something Went Wrong');
        console.log(res.data);
      }
    } catch (er) {
      setScreenloader(false);
      if (er.response?.data?.error) {
        toast.error(er.response.data.error);
      } else if(er.response?.data?.message) {
        toast.error(er.response.data.message);
      }else {
        console.log(er);
        toast.error("Something Went Wrong");
      }
    }
  };

  return (
    <div>
      <AdminDashboardLayout />
      <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
      <div className='content-page-bg'>
        <div className='content-page'>
          <div className='content'>
            <Container fluid className='behind'>
              <Card className='mt-4'>
                <Card.Header>
                 <Card.Title as="h3" className='text-muted'>Create Service</Card.Title>
                </Card.Header>
                <Card.Body>                  
                  <div className='row'>
                    <div className='col-lg-4 col-md-4 col-12 mb-4'>
                      <Card.Subtitle className='mb-2 text-muted'>
                        Name
                      </Card.Subtitle>
                      <Form.Control
                        className="fontBold"
                        required
                        placeholder="Enter Service Name"
                        title="Name"
                        type="text"
                        name="name"
                        value={name}
                        onChange={handleNameChange}
                      />
                    </div>
                    <div className='col-lg-4 col-md-4 col-12 mb-4'>
                      <Card.Subtitle className='mb-2 text-muted'>
                        Slug
                      </Card.Subtitle>
                      <Form.Control
                        className="fontBold"
                        required
                        placeholder="Enter Slug"
                        title="Slug"
                        type="text"
                        name="slug"
                        value={slug}
                        onChange={(e) => setSlug(e.target.value)}
                      />
                    </div>
                    <div className='col-lg-4 col-md-4 col-12 mb-4'>
                      <Card.Subtitle className='mb-2 text-muted'>
                        Active
                      </Card.Subtitle>
                      <Form.Control
                        as="select"
                        className="fontBold"
                        required
                        title="Active"
                        name="active"
                        value={active}
                        onChange={(e) => setActive(parseInt(e.target.value))}
                      >
                        <option value={1}>Yes</option>
                        <option value={0}>No</option>
                      </Form.Control>
                    </div>
                  </div>
                  <div className='row g-0'>
                    <Card.Subtitle className='mb-3 text-muted'>
                      Modules
                    </Card.Subtitle>
                    <ModulesList
                      modules={modules} 
                      setModules={setModules} 
                    />
                  </div>         
                  
                </Card.Body>
                <Card.Footer>
                  <div className='d-flex flex-column flex-sm-row gap-2 mb-3'>
                    <Button className="btn admin-btn" onClick={handleSubmit} variant="success">Create Service</Button>
                    <Button style={{ backgroundColor: '#5f75a5ff', color: '#d8d6d6ff', border: 'none'}} onClick={()=>{navigate(-1)}} variant="danger">Back</Button>
                  </div>
                </Card.Footer>
              </Card>
            </Container>
          </div>
        </div>
      </div>
    </div>
  );
}
